// CMS网站
import Layout from './layout'

export default {
  path: '/cms-website',
  component: Layout,
  meta: { title: 'CMS网站', icon: 'cms', groupTitle: '推广渠道', roles: ['taoke'] },
  name: 'CMSWebSite',
  redirect: 'overview',
  // alwaysShow: true,
  // defaultOpends: true,
  children: [
    {
      path: 'overview',
      name: 'CMSWebSiteOverview',
      component: () => import(/* webpackChunkName: "overview" */ '@v/cmsWebSite/overview'),
      meta: { title: '管理首页' },
    },
    {
      path: 'decoration',
      name: 'cmsWebSiteDecoration',
      component: () => import(/* webpackChunkName: "decoration" */ '@v/cmsWebSite/decoration'),
      meta: {
        title: '店铺装修',
        vipExclude: [0, 1],
      },
      // hidden: true
    },
    {
      path: 'config',
      name: 'CMSWebSiteConfig',
      component: () => import(/* webpackChunkName: "config" */ '@v/cmsWebSite/config'),
      meta: { title: '网站配置', noCache: true },
    },
    {
      path: 'filter',
      name: 'CMSWebSiteFilter',
      component: () => import(/* webpackChunkName: "filter" */ '@v/cmsWebSite/filter'),
      meta: { title: '商品筛选', noCache: true },
    },
    // {
    //   path: 'upgrade',
    //   name: 'CMSWebSiteUpgrade',
    //   hidden: true,
    //   component: () => import(/* webpackChunkName: "upgrade" */ '@v/cmsWebSite/upgrade'),
    //   meta: { title: '专业版升级' },
    // },
  ],
}
